export default {
  pending: 'منتظر تایید',
  accepted: 'تایید شده',
  serviceStarted: 'جاری',
  finished: 'پایان',
  tariffBased: 'تعرفه ای',
  cancelReason: 'دلیل لغو',
  cancelDescription: 'توضیحات لغو',
  generalLoadInformation: 'اطلاعات کلی سفارش',
  package: 'بسته بندی',
  typeOfShippingDocument: 'نوع سند حمل',
  monetaryValue: 'ارزش بار',
  furnitureDate: 'تاریخ اسباب‌کشی',
  furnitureHour: 'ساعت اسباب‌کشی',
  loadDate: 'تاریخ بارگیری',
  loadHour: 'ساعت بارگیری',
  dischargeDate: 'تاریخ تخلیه',
  dischargeTime: 'زمان تخلیه',
  areYouSureToCancel_courierForThisLoad:
    "آیا از لغو ' {courier} ' برای این سفارش اطمینان دارید؟",
  areYouSureToAccept_courierForThisLoad:
    "آیا از تایید ' {courier} ' برای این سفارش اطمینان دارید؟",
  areYouSureToAcceptable_courierForThisLoad:
    "آیا از قبول پیشنهاد ' {courier} ' برای این سفارش اطمینان دارید؟",

  areYouSureToAcceptForThisLoad:
    'آیا از تایید راننده برای این سفارش اطمینان دارید؟',
  insuranceCost: 'هزینه بیمه',
  isTotalAmountOf_rialsApproved:
    'آیا مبغ کل {totalAmount} ریال ({totalAmountToman}) مورد تایید است؟',
  doYouWantAccept_companyForThisLoad:
    "آیا مایل به تایید باربری ' {company} ' برای این سفارش هستید؟",
  totalExcessAmountOf_rialsApproved:
    'آیا مجموع هزینه مازاد {totalExcess} ریال ({total}) مورد تایید است؟',
  totalCostOf_rialsApproved:
    'آیا هزینه کل {totalCost} ریال ({totalCostToman}) مورد تایید است؟',
  areYouSureOfStartingThisLoadWithoutAssigningDriver:
    'آیا از شروع این سفارش بدون تخصیص راننده اطمینان دارید؟',
  areYouSureYouWantToFinishThisLoad:
    'از پایان دادن به این سفارش اطمینان دارید؟',
  areYouSureYouWantToRevert_nameAcceptance:
    'آیا از ابطال تاییدیه {name} اطمینان دارید؟',
  areYouSureYouWantToRevertAssignedDriversOfThisLoad:
    'آیا از ابطال رانندگان اختصاص یافته به این سفارش اطمینان دارید؟',
  revertLoadSteps: 'ابطال مراحل حمل سفارش',
  startWithoutAssignDriver: 'شروع بدون تخصیص راننده',
  startOrderForBranch: 'شروع بار برای شعبه',
  revertStartWithoutAssignDriver: 'ابطال شروع بدون تخصیص راننده',
  areYouSureYouWantToRevertLoadSteps:
    'آیا از ابطال مراحل حمل این سفارش اطمینان دارید؟',
  areYouSureYouWantToRevertStartWithoutAssignDriver:
    'آیا از ابطال شروع بدون تخصیص راننده برای این سفارش اطمینان دارید؟',
  areYouSureYouWantToAssignThisDriverForThisOrder:
    'آیا از تخصیص راننده برای این سفارش اطمینان دارید؟',
  areYouSureYouWantToRevertFinish:
    'آیا از ابطال پایان این سفارش اطمینان دارید؟',
  assignDriver: 'تخصیص راننده',
  reassignDriver: 'تخصیص مجدد راننده',
  areYouSureYouWantToDeleteThisDraft: 'آیا از حذف این پیش نویس اطمینان دارید؟',
  draftDeletedSuccessfully: 'پیش نویس با موفقیت حذف شد',
  pricing: 'تعیین قیمت',
  editPricing: 'ویرایش قیمت',
  acceptOfCourier_: "تایید باربری ' {courier} '",
  areYouSureYouWantToAddOffersOf_companies:
    "از افزودن پیشنهاد باربری (های) ' {companies} ' اطمینان دارید؟",
  areYouSureYouWantToAddOffer: 'از افزودن پیشنهاد اطمینان دارید؟',
  addingOffers: 'افزودن پیشنهاد(ها)',
  assignDriver: 'تخصیص راننده',
  activeTariff: 'تعرفه فعال',
  assignDrivers: 'تخصیص راننده(ها)',
  reassignDrivers: 'تخصیص مجدد راننده(ها)',
  markDriverCoordinatesOnMap: 'موقعیت مکانی راننده را روی نقشه مشخص کنید',
  startMoving: 'شروع حرکت',
  reachingTheOrigin: 'رسیدن به مبدا',
  endOfDownload: 'بارگیری در مبدا',
  reachingTheDestination1: 'رسیدن به مقصد اول',
  reachingTheDestination2: 'رسیدن به مقصد دوم',
  reachingTheDestination3: 'رسیدن به مقصد سوم',
  reachingTheDestination4: 'رسیدن به مقصد چهارم',
  reachingTheDestination: 'رسیدن به مقصد نهایی',
  emptyingTheConsignment: 'اتمام سفارش',
  backTo_: 'بازگشت به {step}',
  updatingPrice: 'بروز رسانی قیمت',
  loadHasBeenFinishedSuccessfully: 'سفارش با موفقیت پایان یافت',
  cancelLoad: 'لغو سفارش',
  loadAsDraft: 'سفارش به عنوان پیش نویس',
  ongoing: 'در حال پیگیری',
  areYouSureYouWantToChangeThisLoadStateToOngoing:
    "از تغییر وضعیت این سفارش به 'در حال پیگیری' اطمینان دارید؟",
  loadStateSuccessfullyChangedToOngoing:
    "وضعیت سفارش با موفقیت به 'در حال پیگیری' تغییر یافت",
  shipmentDrafts: 'پیش نویس سفارش‌ها',
  postalPostageDetail: 'مشخصات مرسوله پستی',
  defaultVehicle: 'خودروی پیشفرض',
  collectionTime: 'زمان جمع آوری',
  stopInPlace: 'توقف در محل',
  returnToOrigin: 'بازگشت به مبدا',
  trackingCodeOf_: 'کد رهگیری {title}',
  orderTracking: 'پیگیری سفارش',
  originAndDestinationInfo: 'اطلاعات مبدا و مقصد',
  estimatedTimeFromOriginToDestination: 'زمان تقریبی مبدا تا مقصد',
  distanceFromOriginToDestination: 'فاصله مبدا تا مقصد',
  deliverer: 'تحویل دهنده',
  transferee: 'تحویل گیرنده',
  plate: 'پلاک',
  floor: 'طبقه',
  unit: 'واحد',
  distanceFromDoorToCar: 'فاصله درب تا خودرو',
  destination1: 'تحویل به مقصد اول',
  destination2: 'تحویل به مقصد دوم',
  destination3: 'تحویل به مقصد سوم',
  destination4: 'تحویل به مقصد چهارم',
  destination5: 'تحویل به مقصد پنجم',
  destination6: 'تحویل به مقصد ششم',
  destination7: 'تحویل به مقصد هفتم',
  destination8: 'تحویل به مقصد هشتم',
  destination9: 'تحویل به مقصد نهم',
  destination10: 'تحویل به مقصد دهم',
  finalDestination: 'تحویل به مقصد نهایی',
  originWeightOfWeighbridge: 'وزن باسکول در مبدا',
  destinationWeightOfWeighbridge: 'وزن باسکول در مقصد',
  receiptOfWeighbridge: 'رسید باسکول',
  laborerCount: 'تعداد کارگر',
  carLoad: 'بارگیر',
  driverMobile: 'موبایل راننده',
  courierShare: 'سهم باربری',
  driverShare: 'سهم راننده',
  carPriceDetails: 'جزئیات قیمت خودرو',
  laborerPriceDetails: 'جزئیات قیمت کارگر',
  technicalForce: 'نیروی فنی',
  costlyItems: 'اقلام هزینه دار',
  otherItems: 'سایر آیتم ها',
  diverSuggestedAmount: 'قیمت پیشنهادی راننده',
  driverName: 'نام راننده',
  driverNationalId: 'شماره ملی راننده',
  vehicleSmartCardNumber: 'کد هوشمند ناوگان',
  courierOffer: 'پیشنهاد باربری ها',
  priced: 'قیمت دهی شده',
  waitingForPricing: 'منتظر قیمت دهی',
  excessCost: 'هزینه مازاد',
  submitExcessCost: 'ثبت هزینه مازاد',
  editExcessCost: 'ویرایش هزینه مازاد',
  acceptCourier: 'تایید باربری',
  submitExcessCostFor_: "ثبت هزینه مازاد برای '{courier}'",
  editExcessCostOf_: "ویرایش هزینه مازاد '{courier}'",
  courierCostDetail_: "جزئیات هزینه '{courier}'",
  totalExcessCost: 'مجموع هزینه مازاد',
  pricing: 'تعیین قیمت',
  pricingCourierOffer_: "تعیین قیمت پیشنهاد '{courier}'",
  editPrice: 'ویرایش قیمت',
  editPriceOfCourierOffer_: "ویرایش قیمت پیشنهاد '{courier}'",
  amountUnderCommissionError:
    'مبلغ وارد شده کمتر از مقدار کمیسیون ({commissionAmount}) می باشد',
  totalAmountUnderCommissionError:
    'جمع مبالغ وارد شده کمتر از مقدار کمیسیون ({commissionAmount}) می باشد',
  addOffer: 'افزودن پیشنهاد',
  noNewOffers: 'پیشنهاد جدیدی موجود نیست',
  noNewPackages: 'بسته بندی جدیدی موجود نیست',
  distance: 'فاصله',
  carPayableAmount: 'قابل پرداخت خودرو',
  laborerPayableAmount: 'قابل پرداخت کارگر',
  carCostDetail: 'جزئیات هزینه خودرو',
  technicalForceCostDetail: 'جزئیات هزینه نیروی فنی',
  costlyItemsCostDetail: 'جزئیات هزینه اقلام هزینه دار',
  otherItemsCostDetail: 'جزئیات هزینه سایر آیتم ها',
  postalPostageSpecifications: 'مشخصات مرسوله پستی',
  monetaryValue: 'ارزش',
  customerMobile: 'موبایل مشتری',
  cancelOrder: 'لغو سفارش',
  continueOrderRegistration: 'ادامه ثبت سفارش',
  areYouSureYouWantToDeleteThisTemplate:
    'آیا از حذف این الگوی سفارش اطمینان دارید؟',
  templateDeletedSuccessfully: 'الگوی سفارش با موفقیت حذف شد',
  loadDetail: 'جزئیات سفارش',
  notStarted: 'شروع نشده',
  loadSteps: 'مراحل حمل سفارش',
  stepsToAdvanceTheLoad: 'مراحل پیش بردن سفارش',
  pleaseSelectVehicle: 'لطفا خودرو رو انتخاب کنید',
  resetCoordinates: 'بازنشانی مختصات',
  stepsHistory: 'تاریخچه مراحل',
  noStepDoneYet: 'هنوز مرحله ای تکمیل نشده',
  noResponseHasBeenRecordedForThisFeedbackYet:
    'هنوز پاسخی برای این بازخورد ثبت نشده است',
  recordResponse: 'ثبت پاسخ',
  noFeedbackHasBeenRecordedForThisShipmentYet:
    'هنوز بازخوردی برای این سفارش ثبت نشده است',
  recordFeedback: 'ثبت بازخورد',
  dischargeDayPart: 'زمان تخلیه',
  orderTime: 'ساعت سفارش',
  orderDate: 'تاریخ سفارش',
  waitMinute: 'مدت زمان توقف',
  roundTrip: 'بازگشت به مبدا',
  updateShipmentMainInfo: 'ویرایش  اطلاعات کلی سفارش',
  loadType: 'نوع بار',
  packageType: 'نوع بسته بندی',
  weight: 'وزن',
  loadWeight: 'وزن بار',
  kilogram: 'کیلوگرم',
  templateId: 'شناسه الگو',
  draftId: 'شناسه پیش نویس',
  otherCost: 'سایر هزینه ها',
  totalCost: 'جمع کل',
  tax: 'مالیات',
  toll: 'عوارض',
  baarbaanetShare: 'سهم باربانت',
  MainCourierShare: 'سهم بابری اصلی',
  pricingType: 'نحوه قیمت دهی',
  loadRange: 'محدوده بار',
  registerOrderTime: 'زمان ثبت سفارش',
  deliveryCode: 'کد تحویل',
  dischargeShipmentCode: 'کد تخلیه سفارش',
  sendDeliveryCodeToCustomer: 'ارسال کد به مشتری',
  deliveryCodeSentSuccessfully: 'کد با موفقیت ارسال شد',
  cancelType: 'نوع لغو',
  cancelLoadReason: 'دلیل لغو سفارش',
  cancelLoadDescription: 'توضیحات لغو سفارش',
  updatePrice: 'بروزرسانی قیمت',
  auctionCommissionWarning:
    'مبلغ وارد شده کمتر از مقدار کمیسیون ({commissionAmount} ریال) می باشد',
  recordOriginWeighbridge: 'ثبت باسکول مبدا',
  recordDestinationWeighbridge: 'ثبت باسکول مقصد',
  finishLoad: 'پایان',
  loadForwardSteps: 'مراحل جلو بردن سفارش',
  loadRevertSteps: 'مراحل ابطال سفارش',
  revertAcceptance: 'ابطال تاییدیه',
  revertDriverAssignment: 'ابطال تخصیص راننده',
  destination: 'مقصد',
  coordinates: 'مختصات',
  cancelReason: 'دلیل لغو سفارش',
  originAndDestinationShouldDiffrent: 'مبدا و مقصد نباید یکسان باشند!',
  addPackage: 'افزودن پکیج',
  atLeastOnePackageIsRequired: 'حداقل یک بسته بندی مورد نیاز است',
  reserveOrderForLater: 'رزرو درخواست برای آینده',
  revertOffer: 'ابطال قبول پیشنهاد',
  atLeastOneEmployeeNeeded: 'برای ادامه انتخاب حداقل یک نیروی فنی الزامی است',
  driversOffers: 'پیشنهادات رانندگان',
  IWantInsurance: 'بیمه می‌خواهم',
  forAddCarToThisBarYouShouldRemoveAllCarExcludedCarsAreYouSure:
    'برای افزودن خودرو به این بار می بایست تمام افراد با فیلد بدون خودرو حذف شوند آیا مطمينید؟',
  carCanNotBeEmpty: 'لیست خودرو نمی تواند خالی باشد ',
  thisEmployeeCantAddedCuzThisLoadHasCar:
    'این کارگر نمیتواند در این بار اضافه شود ابتدا لیست خودرو را خالی کنید',
  employeeShouldExist: 'حداقل یک کارگر می بایست وجود داشته باشد',
  forAddExcludedCarToThisLoadYouShouldRemoveAllCarsAreYouSure:
    'برای انجام این عملیات میبایست تمام خودرو ها را حذف کنید آیا مطمينید؟',
  offer: 'پیشنهاد',
  chooseAtLeastOneTypeOfLoad: 'حداقل یک نوع بار انتخاب نمایید',
  driverInformation: 'اطلاعات راننده',
  loadingStartTime: 'اغاز زمان بارگیری',
  loadingEndTime: 'پایان زمان بارگیری',
  dischargeStartTime: 'زمان اغاز تخلیه',
  dischargeEndTime: 'زمان پایان تخلیه',
  changeDriver: 'تغییر راننده',
  driverEditedSuccessfully: 'راننده با موفقیت ویرایش شد',
  archiveDriver: 'بایگانی راننده',
  deliveryState: 'وضعیت تحویل',
  orderCount: 'تعداد سفارش',
  loading: 'بارگیری'
}
